import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { percentFormatter } from '../formatters/percent';
import { boldFormatter } from '../formatters/bold';
import DiscountPromoCodeNotice, {
    LAYOUTS
} from '../DiscountPromoCodeNotice';
import { customPromoCodeDiscountType } from './propTypes';

import styles from './style.module.scss';

const CustomPromoCodeDiscountNotice = ({
    messageId,
    userId,
    withExpirationDate,
    discountValue,
    code,
    expirationDate,
    termsAndConditionSlug
}) => {
    const discount = (
        <span className={classNames({ [styles.withoutExpirationDate]: !withExpirationDate })}>
            <I18n k="layout.custom_promo_code_discount.value"
                params={{ discountValue: percentFormatter(discountValue / 100) }}
                templates={[boldFormatter]}/>
        </span>
    );

    return (
        <DiscountPromoCodeNotice discount={discount}
            messageId={messageId}
            userId={userId}
            withExpirationDate={withExpirationDate}
            code={code}
            expirationDate={expirationDate}
            termsAndConditionSlug={termsAndConditionSlug}
            layout={LAYOUTS.COLUMN}/>
    );
};

CustomPromoCodeDiscountNotice.propTypes = customPromoCodeDiscountType;

export default CustomPromoCodeDiscountNotice;
